import React, { useCallback, useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Check, ShoppingBag } from 'lucide-react';
const NAMES = ['María Pérez', 'Carlos García', 'Ana Rodríguez', 'Juan Martínez', 'Laura Sánchez', 'David López', 'Carmen Fernández', 'Javier Gómez', 'Lucía Martín', 'Alejandro Díaz', 'Sara Ruiz', 'Miguel Navarro', 'Elena Torres', 'Pablo Castro', 'Andrea Molina', 'Daniel Herrera', 'Natalia Vega', 'Sergio Romero', 'Patricia Ortega', 'Álvaro Ramos'];
const TIMES = ['Hace 2 minutos', 'Hace 5 minutos', 'Hace 8 minutos', 'Hace 12 minutos', 'Hace 20 minutos', 'Hace 35 minutos', 'Hace 1 hora', 'Hace 2 horas', 'Hace 3 horas'];
const pickRandom = <T,>(arr: T[], exclude?: T): T => {
  const filtered = exclude ? arr.filter(item => item !== exclude) : arr;
  return filtered[Math.floor(Math.random() * filtered.length)];
};
const randomInterval = () => Math.floor(Math.random() * 6000) + 12000; // 12–18s
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    time: ''
  });
  const lastNameRef = useRef('');
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const showNotification = useCallback(() => {
    const name = pickRandom(NAMES, lastNameRef.current);
    const time = pickRandom(TIMES);
    lastNameRef.current = name;
    setData({
      name,
      time
    });
    setVisible(true);
    // Hide after 5 seconds
    timeoutRef.current = setTimeout(() => {
      setVisible(false);
      // Schedule next popup after random 12–18s
      timeoutRef.current = setTimeout(() => {
        showNotification();
      }, randomInterval());
    }, 5000);
  }, []);
  useEffect(() => {
    // First popup after 5 seconds
    timeoutRef.current = setTimeout(() => {
      showNotification();
    }, 5000);
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [showNotification]);
  const initials = data.name.split(' ').map(n => n[0]).join('');
  return <AnimatePresence data-id="element-1">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 60,
      scale: 0.95
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 40,
      scale: 0.95
    }} transition={{
      duration: 0.4,
      ease: [0.22, 1, 0.36, 1]
    }} className="fixed bottom-20 md:bottom-6 left-3 md:left-6 z-[60] max-w-[340px] w-[calc(100%-24px)] md:w-auto" data-id="element-2">
          <div className="bg-white rounded-xl shadow-[0_8px_30px_rgba(0,0,0,0.12)] border border-gray-100 p-3.5 flex items-start gap-3" data-id="element-3">
            {/* Avatar */}
            <div className="flex-shrink-0 w-10 h-10 rounded-full bg-gradient-to-br from-violet-500 to-rose-400 flex items-center justify-center" data-id="element-4">
              <ShoppingBag className="w-4.5 h-4.5 text-white" strokeWidth={2.2} data-id="element-5" />
            </div>

            {/* Content */}
            <div className="flex-1 min-w-0" data-id="element-6">
              <p className="font-sans font-semibold text-gray-900 text-[13px] leading-tight" data-id="element-7">
                {data.name}, España
              </p>
              <p className="font-sans font-medium text-violet-600 text-[12px] mt-0.5" data-id="element-8">
                Acaba de comprar
              </p>
              <div className="flex items-center gap-1.5 mt-1.5" data-id="element-9">
                <span className="font-sans text-[11px] text-gray-400" data-id="element-10">
                  {data.time}
                </span>
                <span className="text-gray-300 text-[11px]" data-id="element-11">•</span>
                <span className="inline-flex items-center gap-0.5 text-[11px] text-emerald-600 font-medium" data-id="element-12">
                  <Check className="w-3 h-3" data-id="element-13" />
                  Compra verificada
                </span>
              </div>
            </div>

            {/* Close button */}
            <button onClick={() => setVisible(false)} className="flex-shrink-0 text-gray-300 hover:text-gray-500 transition-colors mt-0.5" aria-label="Cerrar notificación" data-id="element-14">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" data-id="element-15">
                <path d="M10.5 3.5L3.5 10.5M3.5 3.5L10.5 10.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" data-id="element-16" />
              </svg>
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}